'use strict';
const emailOutputUrlDecorator = function (exportResult) {
		exportResult['email-output-url'] = 'mailto:?&body=' + encodeURIComponent(exportResult['output-url'] + '\n\nThe link will be valid for 24 hours');
	}, gmailOutputUrlResultDecorator = function (exportResult) {
		exportResult['gmail-output-url'] = 'https://mail.google.com/mail/u/0/?view=cm&ui=2&cmid=0&fs=1&tf=1&body=' + encodeURIComponent(exportResult['output-url'] + '\n\n the link will be valid for 24 hours');
	};
module.exports = [emailOutputUrlDecorator, gmailOutputUrlResultDecorator];
